import { createSelector } from 'reselect'
import hasReachedMaxFreeSamplesCountCartSelect from 'modules/cart/redux/selectors/has-reached-max-free-samples-count'
import getUnlockedExtraFreeSamplesTierCartSelect from 'modules/cart/redux/selectors/get-unlocked-extra-free-samples-tier'
import { shouldShowSpendMoreToUnlockExtraFreeSamplesBannerCartSelectorUtil } from 'containers/SpendMoreToUnlockExtraFreeSamples/components/Banner/selectors/should-show/utils'
import hasShownSpendMoreToUnlockExtraFreeSamplesModalCartSelect from 'modules/cart/redux/selectors/has-shown-spend-more-to-unlock-extra-free-samples-modal'
import { isReadyCartSelect } from 'modules/cart/redux/selectors/is-ready'
import isSelectFreeBonusDeluxeSamplesStepGiftSelect from 'modules/gift/redux/selectors/is-select-bonus-deluxe-samples-step'
import shouldShowMinimumToCheckOutBannerCartSelect from 'containers/CartMinimumToCheckOutBanner/selectors/should-show'

export const shouldShowSpendMoreToUnlockExtraFreeSamplesBannerCartSelector = ({
  shouldIgnoreMinimumToCheckout
} = {}) => createSelector(
  hasReachedMaxFreeSamplesCountCartSelect,
  getUnlockedExtraFreeSamplesTierCartSelect,
  hasShownSpendMoreToUnlockExtraFreeSamplesModalCartSelect,
  isReadyCartSelect,
  isSelectFreeBonusDeluxeSamplesStepGiftSelect,
  shouldShowMinimumToCheckOutBannerCartSelect,
  (
    hasUnlockedExtraFreeSamplesCount,
    extraFreeSamplesTier,
    hasShownSpendMoreToUnlockExtraFreeSamplesModal,
    isCartReady,
    isSelectFreeBonusDeluxeSamplesStep,
    shouldShowMinimumToCheckOutBanner
  ) => {
    return shouldShowSpendMoreToUnlockExtraFreeSamplesBannerCartSelectorUtil({
      hasUnlockedExtraFreeSamplesCount,
      extraFreeSamplesTier,
      hasShownSpendMoreToUnlockExtraFreeSamplesModal,
      isCartReady,
      isSelectFreeBonusDeluxeSamplesStep,
      shouldShowMinimumToCheckOutBanner,
      shouldIgnoreMinimumToCheckout
    })
  }
)
